
const makeElement = (template) => {
  const decoder = document.createElement('textarea');
  decoder.innerHTML = template;

  const buildContainer = document.createElement('div');
  buildContainer.innerHTML = decoder.value;

  return buildContainer.firstChild;
}

const maybePlaceAndGetRect = (element, container) => {
  if (!document.contains(element)) {
    container.appendChild(element);
  }

  return element.getBoundingClientRect();
};

const positionElementBesideElement = (sourceElement, targetElement, container) => {
  // Position a given sourceElement beside a targetElement

  const targetRect = targetElement.getBoundingClientRect();
  const sourceRect = maybePlaceAndGetRect(sourceElement, container);

  // -- CALCULATE THE HORIZONTAL POSITION OF THE MODAL --

  // Default to the right of the element
  let left;

  const rightPosSpaceTaken = targetRect.right + sourceRect.width;
  const leftPosSpaceTaken = targetRect.left - sourceRect.width;

  if (leftPosSpaceTaken > 0) {
    left = targetRect.left - sourceRect.width;
  } else if (rightPosSpaceTaken < screen.width) {
    left = targetRect.right;
  } else {
    left = (screen.width / 2) - (sourceRect.width / 2);
  }

  // -- CALCULATE THE VERTICAL POSITION OF THE MODAL --
  let top = targetRect.top;

  const topPosSpaceTaken = targetRect.top - sourceRect.height;
  const bottomPosSpaceTaken = targetRect.bottom + sourceRect.height;

  if (topPosSpaceTaken > 0) {
    top = targetRect.top - sourceRect.height;
  } else if (bottomPosSpaceTaken < screen.height) {
    top = targetRect.bottom;
  } else {
    top = (screen.height / 2) - (sourceRect.height / 2);
  }

  sourceElement.style.position = 'fixed';
  sourceElement.style.left = `${left}px`;
  sourceElement.style.top = `${top}px`;

  if (!document.body.contains(sourceElement)) {
    container.appendChild(sourceElement);
  }
}

export { makeElement, positionElementBesideElement };